"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PlayerGameLogsListCtl = /** @class */ (function (_super) {
    __extends(PlayerGameLogsListCtl, _super);
    function PlayerGameLogsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_usr_player_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_id; });
        _this.dk_usr_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_login; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_gws_gameprovider_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_id; });
        _this.dk_gws_gameprovider_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_title; });
        _this.dk_gws_gameprovider_game_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_game_id; });
        _this.dk_gws_gameprovider_game_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_game_title; });
        _this.dk_player_bonus_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_bonus_id; });
        _this.dk_player_bonus_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_bonus_title; });
        _this.dk_bet_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bet_amount; });
        _this.dk_bet_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bet_type_code; });
        _this.dk_bet_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bet_type_title; });
        _this.dk_round_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.round_id; });
        _this.dk_player_money_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_money_balance_before; });
        _this.dk_player_money_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_money_balance_after; });
        _this.dk_bonus_money_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_money_balance_before; });
        _this.dk_bonus_money_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_money_balance_after; });
        _this.dk_bonus_wager_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_wager_balance_before; });
        _this.dk_bonus_wager_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_wager_balance_after; });
        _this.dk_action_type = UIUtils_1.UIUtils.IProp2Str(function (o) { o.action_type; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerGameLogsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PlayerGameLogsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player with id [" + id + "] not found !";
    };
    PlayerGameLogsListCtl.prototype.LoadAllData = function (playerId, onDone) {
        var _this = this;
        webAApi_1.ListPlayerGameLogsByPlayerIdGet.exec({ user_player_id: playerId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    usr_player_id: resp.list[i].usr_player_id,
                    usr_player_login: resp.list[i].usr_player_login,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    gws_gameprovider_id: resp.list[i].gws_gameprovider_id,
                    gws_gameprovider_title: resp.list[i].gws_gameprovider_title,
                    gws_gameprovider_game_id: resp.list[i].gws_gameprovider_game_id,
                    gws_gameprovider_game_title: resp.list[i].gws_gameprovider_game_title,
                    player_bonus_id: resp.list[i].player_bonus_id,
                    player_bonus_title: resp.list[i].player_bonus_title,
                    bet_type_code: resp.list[i].bet_type_code,
                    bet_type_title: resp.list[i].bet_type_title,
                    bet_amount: resp.list[i].bet_amount,
                    round_id: resp.list[i].round_id,
                    player_money_balance_before: resp.list[i].player_money_balance_before,
                    player_money_balance_after: resp.list[i].player_money_balance_after,
                    bonus_money_balance_before: resp.list[i].bonus_money_balance_before,
                    bonus_money_balance_after: resp.list[i].bonus_money_balance_after,
                    bonus_wager_balance_before: resp.list[i].bonus_wager_balance_before,
                    bonus_wager_balance_after: resp.list[i].bonus_wager_balance_after,
                    action_type: resp.list[i].action_type,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerGameLogsListCtl.prototype.LoadRangeData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListPlayersGameLogsByPlayerIdAndDateRangeGet.exec({
            user_player_id: data.playerId,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute,
            limit: data.limit,
            offset: data.offset
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    usr_player_id: resp.list[i].usr_player_id,
                    usr_player_login: resp.list[i].usr_player_login,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    gws_gameprovider_id: resp.list[i].gws_gameprovider_id,
                    gws_gameprovider_title: resp.list[i].gws_gameprovider_title,
                    gws_gameprovider_game_id: resp.list[i].gws_gameprovider_game_id,
                    gws_gameprovider_game_title: resp.list[i].gws_gameprovider_game_title,
                    player_bonus_id: resp.list[i].player_bonus_id,
                    player_bonus_title: resp.list[i].player_bonus_title,
                    bet_amount: resp.list[i].bet_amount,
                    bet_type_code: resp.list[i].bet_type_code,
                    bet_type_title: resp.list[i].bet_type_title,
                    round_id: resp.list[i].round_id,
                    player_money_balance_before: resp.list[i].player_money_balance_before,
                    player_money_balance_after: resp.list[i].player_money_balance_after,
                    bonus_money_balance_before: resp.list[i].bonus_money_balance_before,
                    bonus_money_balance_after: resp.list[i].bonus_money_balance_after,
                    bonus_wager_balance_before: resp.list[i].bonus_wager_balance_before,
                    bonus_wager_balance_after: resp.list[i].bonus_wager_balance_after,
                    action_type: resp.list[i].action_type,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return PlayerGameLogsListCtl;
}(BaseController_1.BaseController));
exports.PlayerGameLogsListCtl = PlayerGameLogsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ctl/PlayerGameLogsListCtl.ts
// module id = 967
// module chunks = 0